<template>
    <div class="d-flex justify-content-between px-5">
        <font-awesome-icon icon="fa-solid fa-arrow-left" class="hg-nav-btn cursor-pointer" @click="prevSlide" />
        
        <font-awesome-icon icon="fa-solid fa-arrow-right" class="hg-nav-btn cursor-pointer" @click="nextSlide" />
    </div>

</template>

<script>
export default {
    name: 'ManualSlideNav',
    methods: {
        nextSlide() {
            const slides = this.$store.getters.allSlides
            let currentIndex = slides.findIndex(slide => slide.path === this.$route.path)
            let nextIndex = (currentIndex + 1) % slides.length
            this.$router.push(slides[nextIndex].path)
        },
        prevSlide() {
            const slides = this.$store.getters.allSlides
            let currentIndex = slides.findIndex(slide => slide.path === this.$route.path)
            let prevIndex = (currentIndex - 1 + slides.length) % slides.length
            this.$router.push(slides[prevIndex].path)
        }
    }
}

</script>


<style scoped>
.hg-nav-btn {
    opacity: 0.8;
    transition: all 0.5s ease-out;
}

.hg-nav-btn:hover {
    opacity: 1;
    transform: scale(1.2);
}


</style>
